import {Component, OnDestroy, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {TypeUtils} from "../shared/utils/type-utils";
import {ActivatedRoute, Router} from '@angular/router';
import * as fromStore from "../store";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Website} from "../websites/website/website";
import {Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../store";
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {Config} from "../config/config";

@Component({
    selector: 'db-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public loading: boolean;
  public showGoHomeButton: boolean = true;
  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService,
    private route: ActivatedRoute,
    private _store: Store<DbStoreState>,
    private router: Router,
    private _routeDataService: RouteDataService,
  ) {}

  ngOnInit() {
    this.loading = true;
    console.log(window.location.href);
    const splitUrl = window.location.href.split('websites/');
    const hasWebsiteContext = splitUrl.length > 1 && splitUrl[1];
    const getWebsitesPart = TypeUtils.isDefined(splitUrl) && TypeUtils.isDefined(splitUrl[1]) ? splitUrl[1] : '';
    const getNumberFromString = (getWebsitesPart.toString()).match(/(\d+)/);
    const websiteId = !TypeUtils.isNull(getNumberFromString) && TypeUtils.isDefined(getNumberFromString[0]) ? getNumberFromString[0] : 0;
    const referrer = new URL(window.location.href).searchParams.get("referrer") || null;
    const demoId = Config.demoDomainId;

    // Only load websites if URL contains website context
    if (hasWebsiteContext) {
      this._store
        .select(fromStore.getWebsitesLoaded)
        .pipe(
          takeUntil(this._destroyStream$),
          filter((loaded: boolean): boolean => !!loaded),
          switchMap(() => this._store.select(fromStore.getWebsites)),
          first()
        )
        .subscribe((websites: Website[]) => {
          if (websites && websites.length === 1 && +websiteId === +demoId && window.location.href.indexOf('ai-builder')) {
            this.router.navigate([`../websites/${websites[0]?.id}/ai-builder`]);
          }
          else {
            this.loading = false;
          }
        });
      this._sendGaEvent(websiteId, referrer);
    } else {
      this.showGoHomeButton = false;
      this.loading = false;
    }
  }

  private _sendGaEvent(websiteId, referrer): void {
    const analyticsData = {
      eventCategory: 'Dashboard Error',
      eventAction: '404 Error',
      eventLabel: '404 Page',
      websiteId: websiteId,
      localReferrer: referrer,
      globalReferrer: document.referrer,
      href: window.location.href
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private modifyQueryParam(paramName: string, paramValue: string): void {
    const queryParams = { ...this.route.snapshot.queryParams };
    if (!(new URL(window.location.href).searchParams.get('page') && new URL(window.location.href).searchParams.get('page') === '404')) {
      queryParams[paramName] = paramValue;
      const separator = window.location.href.includes('?') ? '&' : '?';
      window.location.href += `${separator}page=404`;
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
